import { PERMISSIONS } from '@/generated/permissions'

export const vendorRoutes = [
  {
    component: () => import('@/domains/vendors/pages/IndexPage.vue'),
    meta: {
      anyPerm: [
        PERMISSIONS.VENDOR_READ,
        PERMISSIONS.VENDOR_CREATE,
        PERMISSIONS.VENDOR_UPDATE,
        PERMISSIONS.VENDOR_DELETE,
      ],
      requiresAuth: true,
    },
    name: 'vendors-index',
    path: '/vendors',
  },
  {
    component: () => import('@/domains/vendors/pages/NewPage.vue'),
    meta: { anyPerm: [PERMISSIONS.VENDOR_CREATE], requiresAuth: true },
    name: 'vendors-new',
    path: '/vendors/new',
  },
  {
    component: () => import('@/domains/vendors/pages/DetailPage.vue'),
    meta: { anyPerm: [PERMISSIONS.VENDOR_UPDATE], requiresAuth: true },
    name: 'vendors-detail',
    path: '/vendors/:id',
  },
]
